import * as React from 'react';
import { UIText2, UIText3 } from '@cian/ui-kit';
import { ConditionalWrapper } from '@cian/conditional-component';
import { useIsDesktop } from '@cian/valuation-utils-component';
import * as styles from './styles.css';

import { NBSP } from '../../constants/symbols';

export const PolicyAgreement: React.FC<React.PropsWithChildren<unknown>> = () => {
  const isDesktop = useIsDesktop();

  return (
    <ConditionalWrapper if={isDesktop} ThenComponent={UIText2} ElseComponent={UIText3}>
      <>
        <span className={styles['text']} data-testid="policy">
          {isDesktop ? 'Продолжая, вы соглашаетесь на' : 'Нажимая на кнопку «Оформить заявку» вы соглашаетесь на'}
          {NBSP}
        </span>
        <a href="/help/about/36526/" className={styles['link']}>
          обработку персональных данных
        </a>
      </>
    </ConditionalWrapper>
  );
};

PolicyAgreement.displayName = 'PolicyAgreement';
